import { Injectable } from '@angular/core';
import { AccountStatusService } from 'common/services/account-status.service';
import { AccountAdminProgramEnrollments, ProgramDetails } from '../models/account-admin-program.model';
import { AccountStatusResponse } from 'common/models/account-status';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

export enum LoggedInUserType {
    INTERNAL = 'Internal',
    DISTRIBUTOR = 'Distributor',
    DOMESTIC_DISTRIBUTOR = 'Domestic Distributor',
}

export enum FinalApprovedBy {
    INTERNAL = '1',
    DISTRIBUTOR = '2'
}

@Injectable({ providedIn: 'root' })
export class ManageEnrollmentsService {
    public showDropdowns$ = new BehaviorSubject<Boolean>(false);
    public showDropdownsinCompany$ = new BehaviorSubject<boolean>(false);

    public userCompanyType: string;
    public finalApprovedByType: string | null;
    public enrollmentWorkflow: string | null;
    constructor(
        public translate: TranslateService,
        private readonly statusService: AccountStatusService
    ) { }

    checkDropdownVisibility(data : ProgramDetails) {
        this.statusService.getUserStatus().subscribe((result: AccountStatusResponse) => {
            this.userCompanyType = (result.company.companyType.name);
            this.finalApprovedByType = data.finalApprovedBy?.desc ? data.finalApprovedBy.desc : null;
            this.enrollmentWorkflow = data.enrollmentWorkflow?.name ? data.enrollmentWorkflow.name : null;

            if (this.enrollmentWorkflow === null) {
                if (
                    (this.finalApprovedByType === LoggedInUserType.INTERNAL && this.userCompanyType === LoggedInUserType.INTERNAL) ||
                    (this.finalApprovedByType === LoggedInUserType.DISTRIBUTOR && this.userCompanyType === LoggedInUserType.DOMESTIC_DISTRIBUTOR)
                ) {
                    this.showDropdowns$.next(true);
                }
                else {
                    this.showDropdowns$.next(false);
                }
            }
            else if (this.finalApprovedByType === null) {
                this.showDropdowns$.next(true);
            }
            else {
                this.showDropdowns$.next(false);
            }
        });

        return this.showDropdowns$;
    }

    checkDropdownVisibilityFromCompany(enrollment: AccountAdminProgramEnrollments, userCompanyType: string) {
        const finalApprovedByType = enrollment.finalApprovedBy ? enrollment.finalApprovedBy : null;
        const enrollmentWorkflow = enrollment.enrollmentWorkflowId ? enrollment.enrollmentWorkflowId : null;

        if (enrollmentWorkflow === null) {
            if (
                (finalApprovedByType === FinalApprovedBy.INTERNAL && userCompanyType === LoggedInUserType.INTERNAL) ||
                    (finalApprovedByType === FinalApprovedBy.DISTRIBUTOR && userCompanyType === LoggedInUserType.DOMESTIC_DISTRIBUTOR)
            ) {
                this.showDropdownsinCompany$.next(true);
            }
            else {
                this.showDropdownsinCompany$.next(false);
            }
        }
        else if (finalApprovedByType === null) {
            this.showDropdownsinCompany$.next(true);
        }
        else {
            this.showDropdownsinCompany$.next(false);
        }

        return this.showDropdownsinCompany$.value;
    }
}
